module.exports = __webpack_public_path__ + "img/hands-asl-interpreting.75e20f48.svg";